"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var API = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_API_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 16,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m0 11.75 1.52-7.51h2.371l1.563 7.51H3.807l-.28-1.605H1.93l-.284 1.604H0Zm2.184-3.032h1.092l-.266-1.52a7.534 7.534 0 0 0-.094-.546l-.105-.598-.074-.524c-.02.147-.049.322-.084.524a101.657 101.657 0 0 0-.199 1.144l-.27 1.52ZM6.023 11.75V4.26h2.328c.832 0 1.444.206 1.836.619.398.412.598 1.003.598 1.772 0 .483-.084.92-.252 1.311a1.92 1.92 0 0 1-.787.913c-.356.216-.835.325-1.437.325H7.68v2.548H6.023Zm2.119-3.965c.237 0 .43-.039.576-.115a.746.746 0 0 0 .336-.367c.07-.161.105-.357.105-.588 0-.35-.077-.612-.23-.786-.155-.175-.385-.263-.693-.263H7.68v2.119h.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.69 10.512v1.237H16v-1.237l-1.311-.158V5.656L16 5.499V4.26h-4.31v1.238l1.352.157v4.699l-1.353.157Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_API_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = API;
exports["default"] = _default;